export default "__VITE_ASSET__CF1Yz25d__"